import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type * as api from '../../../api';

export type PermissionOriginTagsProps = { origins: api.RoleSpecsFragment[] };

const colorMap = {
    fromRole: 'geekblue',
    fromUser: 'gold',
};

export const PermissionOriginTags = ({ origins }: PermissionOriginTagsProps) => {
    const { t } = useTranslation(['userDetails']);

    if (origins.length === 0) {
        return (
            <Tag color={colorMap.fromUser || 'default'}>
                <Space>
                    <Typography.Text style={{ color: 'inherit' }}>
                        {t('userDetails:permissionOrigin.fromUser')}
                    </Typography.Text>
                </Space>
            </Tag>
        );
    }

    return (
        <Space>
            <Typography.Text style={{ color: 'inherit' }}>{t('userDetails:permissionOrigin.fromRole')}</Typography.Text>
            {origins.map(role => (
                <Tag key={role.id} color={colorMap.fromRole || 'default'}>
                    <Typography.Text style={{ color: 'inherit' }}>{role.displayName}</Typography.Text>
                </Tag>
            ))}
        </Space>
    );
};
